import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(() => localStorage.getItem("gs_cookie_consent") !== "1");

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem("gs_cookie_consent", "1");
    setVisible(false);
  };

  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-4 sm:max-w-md z-[45] rounded-xl border border-border bg-card/95 backdrop-blur-xl shadow-2xl p-4">
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-lg bg-primary/15 flex items-center justify-center shrink-0">
          <Cookie className="h-4 w-4 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-foreground">We use essential cookies to keep you signed in and to run the app.</p>
          <p className="text-xs text-muted-foreground mt-1">
            See our <Link to="/privacy" className="underline hover:text-foreground">Privacy Policy</Link> for details.
          </p>
          <div className="flex items-center gap-2 mt-3">
            <Button data-testid="cookie-accept" onClick={accept} size="sm" className="bg-primary hover:bg-primary/90 text-white h-8">
              Got it
            </Button>
            <Link to="/privacy" data-testid="cookie-learn-more" className="text-xs text-muted-foreground hover:text-foreground px-2">Learn more</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
